import { getCachedPreviewUrl } from "./attachmentPreview";

/**
 * 从话题/文章详情接口 payload 中解析版主列表（字段名兼容多种后端命名）。
 * @param {object} data - 通常为 GET /social/article/:id 的 data
 * @returns {Array<{ id: string, username: string, avatar: string, avatarUrl: string }>}
 */
export function normalizeModeratorsFromArticleData(data) {
  if (!data || typeof data !== "object") return [];
  const raw =
    data.moderatorInfos ??
    data.moderators ??
    data.moderatorList ??
    data.adminUsers ??
    data.admins ??
    data.ownerList;
  if (!Array.isArray(raw)) return [];
  return raw.map((m, i) => {
    const id = String(m.userId ?? m.id ?? m.uid ?? `mod-${i}`);
    const username =
      m.moderatorNickName ??
      m.username ??
      m.name ??
      m.nickName ??
      m.nickname ??
      "Moderator";
    const avRaw =
      m.moderatorAvatarUrl ?? m.avatar ?? m.avatarId ?? "";
    const avStr = avRaw != null ? String(avRaw).trim() : "";
    const isUrl =
      /^https?:\/\//i.test(avStr) || avStr.startsWith("data:");
    return {
      id,
      username,
      avatar: isUrl ? "" : avStr,
      avatarUrl: isUrl ? avStr : getCachedPreviewUrl(avStr) || "",
    };
  });
}

/**
 * @param {Array<{ id?: string, username?: string }>|null|undefined} moderators
 * @returns {(userId: *, username: *, item?: object) => boolean}
 */
export function createTopicModeratorChecker(moderators) {
  const list = Array.isArray(moderators) ? moderators.filter(Boolean) : [];
  const idSet = new Set();
  const nameSet = new Set();
  for (const m of list) {
    if (m?.id != null && String(m.id).trim() !== "") {
      idSet.add(String(m.id).trim());
    }
    const nm = m?.username != null ? String(m.username).trim() : "";
    if (nm) nameSet.add(nm);
  }

  return (userId, username, item) => {
    if (item) {
      if (item.isModerator === true) return true;
      if (item.authenticatedModerator === true) return true;
      if (item.userType === "MODERATOR" || item.userType === "moderator")
        return true;
    }
    if (list.length === 0) return false;
    const uid = userId != null ? String(userId).trim() : "";
    if (uid && idSet.has(uid)) return true;
    const un = username != null ? String(username).trim() : "";
    if (un && nameSet.has(un)) return true;
    return false;
  };
}
